import { moduleProviderFactory } from "core/providers";
import {
    VendorsEdit,
    VendorsList,
} from "application/vendors/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.vendors",
                pattern: "/vendors",
                children: [
                    {
                        name: "master.app.main.vendors.list",
                        pattern: "",
                        tabTitle: "VENDORS.LIST.TITLE",
                        component: VendorsList, 
                        data: { title: "VENDORS.LIST.TITLE_SECONDARY" },
                    },
                    {
                        name: "master.app.main.vendors.create",
                        pattern: "/create",
                        tabTitle: "VENDORS.CREATE.TITLE",
                        component: VendorsEdit,
                        authorization: "portalSection.create",
                        data: { title: "VENDORS.CREATE.TITLE" },
                    },
                    {
                        name: "master.app.main.vendors.edit",
                        pattern: "/edit/:id",
                        tabTitle: "VENDORS.EDIT.TITLE",
                        component: VendorsEdit,
                        authorization: "portalSection.update",
                        data: { title: "VENDORS.EDIT.TITLE" },
                    },
                ],
            },
        ],

        menu: [
            {
                title: "MENU.MASTER_DATA",
                order: 7,
                icon: "database",
                authorization: "administrationSection.read",
                subMenu: [
                    {
                        title: "MENU.VENDORS",
                        route: "master.app.main.vendors.list",
                        order: 11.1,
                        icon: "users",
                        authorization: "vendorSection.read",
                    },
                ],
            },
        ],
    });
})();
